module.exports = __webpack_public_path__ + "media/application/images/drawn-heart-58c1885d6e9ddabaa8668c3f11941771.svg";